import React, { useMemo, useState } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Formik, Form } from 'formik';
import { useLoader } from '../../../contexts/LoaderContext';
import EssentialSectionsWrapper from './components/EssentialSectionsWrapper';

import './style.css';
import {
  SHOP_TYPES,
  DAYS_OF_WEEK,
  SOCIAL_MEDIA_OPTIONS,
  getPaymentMethods,
  VALIDATION_SCHEMA
} from './constant.js';
import { useShopConfig } from '../../../hooks/useShopConfig';

function ShopConfig() {
  const { showLoader, hideLoader } = useLoader();
  const {
    toastRef,
    handleSaveClick,
    stateRef,
    userRecord
  } = useShopConfig(showLoader, hideLoader);


  const [initialValues, setInitialValues] = useState({
    shopName: userRecord?.shopName || stateRef.current.shopName || '',
    shopType: userRecord?.shopType || stateRef.current.shopType || '',
    contactEmail: userRecord?.contactEmail || stateRef.current.contactEmail || '',
    contactPhone: userRecord?.contactPhone || stateRef.current.contactPhone || '',
    storeAddress: userRecord?.storeAddress || stateRef.current.storeAddress || '',
    directions: userRecord?.directions || stateRef.current.directions || '',
    businessHours: userRecord?.businessHours || stateRef.current.businessHours || [],
    markerPosition: userRecord?.markerPosition || stateRef.current.currentLocation ? {
      lat: (userRecord?.markerPosition?.lat || stateRef.current.currentLocation?.lat) || 14.5995,
      lng: (userRecord?.markerPosition?.lng || stateRef.current.currentLocation?.lng) || 120.9842
    } : null
  });

  const handleComplete = async (values, validateForm, setFieldTouched) => {
    const errors = await validateForm();

    if (Object.keys(errors).length > 0) {
      Object.keys(errors).forEach(field => {
        setFieldTouched(field, true, false);
      });

      const firstErrorField = Object.keys(errors)[0];
      const errorElement = document.querySelector(`[name="${firstErrorField}"]`);
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      return false;
    }

    showLoader();
    try {
      const shopData = {
        shopName: values.shopName,
        storeAddress: values.storeAddress,
        directions: values.directions,
        contactEmail: values.contactEmail,
        contactPhone: values.contactPhone,
        businessHours: values.businessHours,
        markerPosition: values.markerPosition
      };

      const success = await handleSaveClick(true, shopData);
      return success;
    } finally {
      hideLoader();
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={VALIDATION_SCHEMA}
      enableReinitialize
    >
      {({ errors, touched, values, handleChange, handleBlur, setFieldValue, validateForm, setFieldTouched }) => (
        <Form className="shop-config-layout">
          <Toast ref={toastRef} />
          <div className="shop-config-container">
            <EssentialSectionsWrapper
              errors={errors}
              touched={touched}
              values={values}
              handleChange={handleChange}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              shopTypes={SHOP_TYPES}
              stateRef={stateRef}
              mapContainerStyle={{
                width: '100%',
                height: '100%',
                flex: '1 1 auto',
              }}
              mapOptions={{
                disableDefaultUI: false,
                zoomControl: !stateRef.current.setupCompleted,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                rotateControl: false,
                draggable: !stateRef.current.setupCompleted,
                scrollwheel: !stateRef.current.setupCompleted,
                disableDoubleClickZoom: stateRef.current.setupCompleted,
                gestureHandling: stateRef.current.setupCompleted ? 'none' : 'auto'
              }}
              currentLocation={stateRef.current.currentLocation}
              businessHours={values.businessHours}
              handleBusinessHoursChange={(dayValue, field, value) => {
                const updatedHours = values.businessHours.map(day =>
                  day.day === dayValue ? { ...day, [field]: value } : day
                );
                setFieldValue('businessHours', updatedHours);
              }}
              DAYS_OF_WEEK={DAYS_OF_WEEK}
              setupCompleted={stateRef.current.setupCompleted}
            />
            <div className="form-navigation">
              <Button
                type="button"
                label={stateRef.current.setupCompleted ? "Update Configuration" : "Complete Setup"}
                icon={stateRef.current.setupCompleted ? "pi pi-save" : "pi pi-check"}
                onClick={() => handleComplete(values, validateForm, setFieldTouched)}
                loading={stateRef.current.isLoading}
                className="p-button-primary"
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

function ShopConfigWrapper() {
  return (
      <ShopConfig />
  );
}

export default ShopConfigWrapper;